<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem" style="background-image: url('../../assets/images/bg/3.jpg');" data-scrollax="properties: { translateY: '30%' }"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Our Last News</span></h2>
            <span class="section-separator"></span>
            <h4>Get ready to start your exciting journey.
                Our agency will lead you through the amazing digital world.</h4>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="#sec1" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<section class="gray-bg no-top-padding-sec" id="sec1">
    <div class="container">
        <div class="breadcrumbs inline-breadcrumbs fl-wrap block-breadcrumbs">
            <a routerLinkActive="active" routerLink="">Home</a><a href="#">Blog</a> <span>News</span>
            <div class="showshare brd-show-share color2-bg"> <i class="fas fa-share"></i> Share </div>
        </div>
        <div class="share-holder hid-share sing-page-share top_sing-page-share">
            <div class="share-container  isShare"></div>
        </div>
        <div class="post-container fl-wrap">
            <div class="row">
                <!-- blog content-->
                <div class="col-md-8">
                    <!-- article> -->
                    <article class="post-article">
                        <div class="list-single-main-item fl-wrap block_box">
                            <h2 class="post-opt-title"><a routerLinkActive="active" routerLink="news-details">Here’s What People Are Saying About Us.</a></h2>
                            <p>About business in maharashtra </p>
                            <p>Get ready to start your exciting journey. Our agency will lead you through the amazing digital world.</p>
                            <span class="fw-separator"></span>
                            <div class="post-author">
                                <a href="#" title="Author: Alisa Noory"><img src="../../assets/images/avatar/1.jpg" alt="Alisa Noory" loading="lazy" decoding="async"><span>By , Alisa Noory</span></a>
                            </div>
                            <div class="post-opt">
                                <ul class="no-list-style">
                                    <li><i class="fal fa-calendar"></i> <span>25 April 2018</span></li>
                                    <li><i class="fal fa-eye"></i> <span>264</span></li>
                                    <li><i class="fal fa-tags"></i> <a href="#">Photography</a> , <a href="#">Design</a> </li>
                                </ul>
                            </div>
                            <a routerLinkActive="active" routerLink="news-details" class="btn color2-bg  float-btn">Read more<i class="fal fa-angle-right"></i></a>
                        </div>
                    </article>
                    <!-- article end -->
                </div>
                <!-- blog conten end-->
                <!-- blog sidebar -->
                <div class="col-md-4">
                    <div class="box-widget-wrap fl-wrap fixed-bar">
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Search In Blog</h3>
                            </div>
                            <div class="box-widget fl-wrap">
                                <div class="box-widget-content">
                                    <div class="search-widget">
                                        <form action="#" class="fl-wrap">
                                            <input name="se" id="se" type="text" class="search" placeholder="Search.." value="" />
                                            <button class="search-submit color2-bg" id="submit_btn"><i class="fal fa-search"></i> </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Popular Posts</h3>
                            </div>
                            <div class="box-widget  fl-wrap">
                                <div class="box-widget-content">
                                    <!--widget-posts-->
                                    <div class="widget-posts  fl-wrap">
                                        <ul class="no-list-style">
                                            <li>
                                                <div class="widget-posts-img">
                                                    <a href="blog-single.html" title="Read article"><img src="../../assets/images/gallery/thumbnail/1.png" alt="Article thumbnail" loading="lazy" decoding="async"></a>
                                                </div>
                                                <div class="widget-posts-descr">
                                                    <h4><a href="javascript:void(0)">Nullam dictum felis</a></h4>
                                                    <div class="geodir-category-location fl-wrap"><a href="#"><i class="fal fa-calendar"></i> 27 Mar 2019</a></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="widget-posts-img">
                                                    <a routerLinkActive="active" routerLink="news-details" title="Read article"><img src="../../assets/images/gallery/thumbnail/1.png" alt="Article thumbnail" loading="lazy" decoding="async"></a>
                                                </div>
                                                <div class="widget-posts-descr">
                                                    <h4><a href="javascript:void(0)">Scrambled it to mak</a></h4>
                                                    <div class="geodir-category-location fl-wrap"><a href="#"><i class="fal fa-calendar"></i> 12 May 2018</a></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="widget-posts-img">
                                                    <a routerLinkActive="active" routerLink="news-details" title="Read article"><img src="../../assets/images/gallery/thumbnail/1.png" alt="Article thumbnail" loading="lazy" decoding="async"></a>
                                                </div>
                                                <div class="widget-posts-descr">
                                                    <h4><a href="javascript:void(0)">Fermentum nis type</a></h4>
                                                    <div class="geodir-category-location fl-wrap"><a href="#"><i class="fal fa-calendar"></i>22 Feb  2018</a></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="widget-posts-img">
                                                    <a routerLinkActive="active" routerLink="news-details" title="Read article"><img src="../../assets/images/gallery/thumbnail/1.png" alt="Article thumbnail" loading="lazy" decoding="async"></a>
                                                </div>
                                                <div class="widget-posts-descr">
                                                    <h4><a href="javascript:void(0)">Rutrum elementum</a></h4>
                                                    <div class="geodir-category-location fl-wrap"><a href="#"><i class="fal fa-calendar"></i> 7 Mar 2017</a></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- widget-posts end-->
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap">
                            <div class="banner-wdget fl-wrap">
                                <div class="overlay"></div>
                                <div class="bg" data-bg="../../assets/images/bg/1.jpg"></div>
                                <div class="banner-wdget-content fl-wrap">
                                    <h4>Whant to be notified about new post and news ? Subscribe For a Newsletter.</h4>
                                    <a href="#subscribe" class="custom-scroll-link color-bg"> Sign up</a>
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Tags</h3>
                            </div>
                            <div class="box-widget fl-wrap">
                                <div class="box-widget-content">
                                    <div class="list-single-tags tags-stylwrap">
                                        <a href="#">Hotel</a>
                                        <a href="#">Hostel</a>
                                        <a href="#">Room</a>
                                        <a href="#">Spa</a>
                                        <a href="#">Restourant</a>
                                        <a href="#">Parking</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->
                        <!--box-widget-item -->
                        <div class="box-widget-item fl-wrap block_box">
                            <div class="box-widget-item-header">
                                <h3>Categories</h3>
                            </div>
                            <div class="box-widget fl-wrap">
                                <div class="box-widget-content">
                                    <ul class="cat-item no-list-style">
                                        <li><a href="#">Standard</a> <span>3</span></li>
                                        <li><a href="#">Video</a> <span>6 </span></li>
                                        <li><a href="#">Gallery</a> <span>12 </span></li>
                                        <li><a href="#">Quotes</a> <span>4</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!--box-widget-item end -->
                    </div>
                </div>
                <!-- blog sidebar end -->
            </div>
        </div>
    </div>
</section>
<div class="limit-box fl-wrap"></div>